var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "64px",
    height: "64px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: 32,
    cy: 32.5,
    r: 30.775,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4e9c3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#f8eecd",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#fdf4dc",
    stopOpacity: 0.01961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6e1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 22.995,
    y1: 60.238,
    x2: 13.165,
    y2: 30.11,
    gradientUnits: "userSpaceOnUse",
    id: "color-2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41bfec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#4cc5ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#6bd4f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ae4fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 19.534,
    y1: 61.367,
    x2: 9.705,
    y2: 31.239,
    gradientUnits: "userSpaceOnUse",
    id: "color-3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41bfec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#4cc5ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#6bd4f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ae4fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 21.652,
    y1: 60.676,
    x2: 11.822,
    y2: 30.549,
    gradientUnits: "userSpaceOnUse",
    id: "color-4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41bfec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#4cc5ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#6bd4f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ae4fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 36.994,
    y1: 55.671,
    x2: 27.164,
    y2: 25.543,
    gradientUnits: "userSpaceOnUse",
    id: "color-5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41bfec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#4cc5ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#6bd4f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ae4fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 56.056,
    y1: 49.451,
    x2: 46.226,
    y2: 19.324,
    gradientUnits: "userSpaceOnUse",
    id: "color-6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41bfec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#4cc5ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#6bd4f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ae4fd"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,40.017v0c0.009,2.755 2.245,4.983 5,4.983h3c2.761,0 5,2.238 5,5v0c0,2.762 -2.238,5 -5,5h-0.566c-1.914,0 -3.434,1.52 -3.434,3.395v0c0,1.991 1.614,3.605 3.605,3.605h48.895c1.926,0 3.49,-1.556 3.5,-3.483v-0.017c0.01,-1.93 -1.552,-3.5 -3.483,-3.5h-0.517c-2.209,0 -4,-1.791 -4,-4v0c0,-2.209 1.791,-4 4,-4h3c2.761,0 5,-2.239 5,-5v0c0,-2.761 -2.239,-5 -5,-5v0c-1.657,0 -3,-1.343 -3,-3v0c0,-1.657 1.343,-3 3,-3h-0.5c3.038,0 5.5,-2.462 5.5,-5.5v0c0,-3.038 -2.462,-5.5 -5.5,-5.5h-2.904c-2.209,0 -4,-1.791 -4,-4v0c0,-2.209 1.791,-4 4,-4h2.904c2.485,0 4.5,-2.015 4.5,-4.5v0c0,-2.485 -2.015,-4.5 -4.5,-4.5h-27.5h-26c-2.209,0 -4,1.791 -4,4v0c0,2.209 1.791,4 4,4h12.5c1.933,0 3.5,1.567 3.5,3.5v0c0,1.933 -1.567,3.5 -3.5,3.5h-12.5c-2.209,0 -4,1.791 -4,4v0c0,2.209 1.791,4 4,4h1.5c2.485,0 4.5,2.015 4.5,4.5v0c0,2.485 -2.015,4.5 -4.5,4.5h-1.5c-2.768,0 -5.009,2.249 -5,5.017z",
    fill: "url(#color-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.528,27.579c-0.117,0 -0.146,-0.058 -0.088,-0.146l0.613,-0.789c0.058,-0.088 0.204,-0.146 0.321,-0.146h10.429c0.117,0 0.146,0.088 0.088,0.175l-0.497,0.76c-0.058,0.088 -0.204,0.175 -0.292,0.175z",
    fill: "url(#color-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.117,30.267c-0.117,0 -0.146,-0.058 -0.088,-0.146l0.613,-0.789c0.058,-0.088 0.204,-0.146 0.321,-0.146h13.321c0.117,0 0.175,0.088 0.146,0.175l-0.234,0.701c-0.029,0.117 -0.146,0.175 -0.263,0.175z",
    fill: "url(#color-3)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#color-4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.186,32.954c-0.117,0 -0.146,-0.088 -0.088,-0.175l0.409,-0.73c0.058,-0.088 0.175,-0.175 0.292,-0.175h5.843c0.117,0 0.175,0.088 0.175,0.204l-0.058,0.701c0,0.117 -0.117,0.204 -0.204,0.204z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.51,27.053c-1.84,0.467 -3.097,0.818 -4.908,1.285c-0.438,0.117 -0.467,0.146 -0.847,-0.292c-0.438,-0.497 -0.76,-0.818 -1.373,-1.11c-1.84,-0.906 -3.622,-0.643 -5.288,0.438c-1.986,1.285 -3.009,3.184 -2.98,5.55c0.029,2.337 1.636,4.265 3.944,4.586c1.986,0.263 3.652,-0.438 4.966,-1.928c0.263,-0.321 0.497,-0.672 0.789,-1.081c-1.052,0 -2.366,0 -5.638,0c-0.613,0 -0.76,-0.38 -0.555,-0.876c0.38,-0.906 1.081,-2.425 1.49,-3.184c0.088,-0.175 0.292,-0.467 0.73,-0.467c1.49,0 6.982,0 10.634,0c-0.058,0.789 -0.058,1.578 -0.175,2.366c-0.321,2.103 -1.11,4.031 -2.395,5.726c-2.103,2.775 -4.849,4.499 -8.326,4.966c-2.863,0.38 -5.521,-0.175 -7.858,-1.928c-2.162,-1.636 -3.389,-3.798 -3.71,-6.485c-0.38,-3.184 0.555,-6.047 2.483,-8.559c2.074,-2.717 4.82,-4.44 8.18,-5.054c2.746,-0.497 5.375,-0.175 7.741,1.431c1.548,1.022 2.658,2.425 3.389,4.119c0.174,0.264 0.057,0.41 -0.293,0.497z",
    fill: "url(#color-5)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#color-6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.179,43.208c-2.658,-0.058 -5.083,-0.818 -7.128,-2.571c-1.724,-1.49 -2.804,-3.389 -3.155,-5.638c-0.526,-3.301 0.38,-6.222 2.366,-8.822c2.133,-2.804 4.703,-4.265 8.18,-4.879c2.98,-0.526 5.784,-0.234 8.326,1.49c2.308,1.578 3.739,3.71 4.119,6.515c0.497,3.944 -0.643,7.157 -3.36,9.903c-1.928,1.957 -4.294,3.184 -7.011,3.739c-0.789,0.146 -1.577,0.176 -2.337,0.263zM56.132,31.406c-0.029,-0.38 -0.029,-0.672 -0.088,-0.964c-0.526,-2.892 -3.184,-4.528 -5.959,-3.885c-2.717,0.613 -4.47,2.337 -5.112,5.083c-0.526,2.279 0.584,4.586 2.688,5.521c1.607,0.701 3.213,0.613 4.762,-0.175c2.307,-1.198 3.563,-3.068 3.709,-5.58z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGo);
export default __webpack_public_path__ + "static/media/go.789abee0ec79a2f0049cff204cddbb64.svg";
export { ForwardRef as ReactComponent };